import { Reducer } from 'redux';
import { PURGE } from 'redux-persist';
import { AchievementsState, AchievementsTypes } from './types';

const INITIAL_STATE: AchievementsState = {
    loading: false,
    hasError: false,
    success: false,
    personBadges: [],
};

const reducer: Reducer<AchievementsState> = (state: AchievementsState = INITIAL_STATE, action) => {
    switch (action.type) {
        case PURGE:
            return { ...INITIAL_STATE };
        case AchievementsTypes.UPDATE_ACHIEVEMENTS_NOTIFICATION_REQUEST:
            return { ...state, loading: true, success: false, hasError: false };
        case AchievementsTypes.UPDATE_ACHIEVEMENTS_NOTIFICATION_SUCCESS:
            return { ...state, loading: false, success: true, hasError: false };
        case AchievementsTypes.UPDATE_ACHIEVEMENTS_NOTIFICATION_FAILURE:
            return { ...state, loading: false, success: false, hasError: true };
        case AchievementsTypes.UPDATE_ACHIEVEMENTS_INFO_REQUEST:
            return { ...state, loading: true, success: false, hasError: false };
        case AchievementsTypes.UPDATE_ACHIEVEMENTS_INFO_SUCCESS:
            return { ...state, loading: false, success: true, hasError: false };
        case AchievementsTypes.UPDATE_ACHIEVEMENTS_INFO_FAILURE:
            return { ...state, loading: false, success: false, hasError: true };
        case AchievementsTypes.LIST_ACHIEVEMENTS_REQUEST:
            return { ...state, loading: true, success: false, hasError: false };
        case AchievementsTypes.LIST_ACHIEVEMENTS_SUCCESS:
            return { ...state, loading: false, success: true, hasError: false, personBadges: action.payload };
        case AchievementsTypes.LIST_ACHIEVEMENTS_FAILURE:
            return { ...state, loading: false, success: false, hasError: true };
        default:
            return state;
    }
};

export default reducer;
